<div class="overall_content">
    <div class="row">
        <div class="col-sm-6">
            <div class="first_div_container">
                <div class="select_container row">
                    <div class="col-md-8 offset-md-2">
                        <div class="form-group row">
                            <label for="selectpc" class="col-4 col-form-label" style="padding-left: 0 !important;">Select PC:</label>
                            <div class="col-8" style="padding-right: 0 !important;">
                                <select class="form-control" id="selectpc" (change)="onSelectChange($event.target.value)">
                                    <ng-container *ngFor="let item of selectData">
                                        <option [selected]="selectedValue == item.value" [value]="item.value">{{ item.name }}</option>

                                    </ng-container>
                                  </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="action_container col-md-8 offset-md-2">
                        <div class="action_div">
                            <div class="buttons_wrapper">
                                <button type="button" (click)="issueNewGuest()" [disabled]="isLoading" class="btn btn-primary btn-block btn-lg action_button">
                                    <span class="icon mr-2"><i class="fa fa-plus"></i></span>
                                    <span class="new_guest">Issue New Guest</span>
                                </button>
                                <button type="button" (click)="issueCopyGuest()" [disabled]="isLoading" class="btn btn-primary btn-block btn-lg action_button">
                                    <span class="icon mr-2"><i class="fa fa-copy"></i></span>
                                    <span class="copy_guest">Issue Copy Guest</span>
                                </button>
                                <button type="button" (click)="deleteGuestCard()" class="btn btn-primary btn-block btn-lg action_button" disabled>
                                    <span class="icon mr-2"><i class="fa fa-trash"></i></span>
                                    <span class="delete">Delete Guest Card</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="second_div_container">
                <div class="loop_icon_div">
                    <div class="loop_icon">
                        <div class="img_div animate_logo" [class.animate_logo]="isLoading">
                            <img src="../../../assets/AMADEO LOGO 2.png" alt="loop icon">
                        </div>
                        <div class="loop_text mt-3" [class.hidden]="!isLoading">Processing, Please wait...</div>
                    </div>
                </div>
                <div class="result">
                    <div class="card_issued animate__heartBeat text-success" *ngIf="isCardIssued">{{ successMsg }} <span><i class="fa fa-check-circle text-success ml-2"></i></span></div>
                    <div class="card_issued animate__heartBeat text-danger" *ngIf="isCardFailed">{{ errorMsg }} <span><i class="fa fa-times-circle text-danger ml-2"></i></span></div>
                    <div class="card_issued animate__heartBeat text-danger" *ngIf="isTimeOut">Time out, try again <span><i class="fa fa-times-circle text-danger ml-2"></i></span></div>
                </div>
            </div>
        </div>
    </div>
</div>




<button style="display: none;" type="button" class="btn btn-primary" data-toggle="modal" data-target="#reservationMenu" #openModal>
    Launch demo modal
  </button>



<div class="modal fade" id="reservationMenu" tabindex="-1" role="dialog" aria-labelledby="reservationMenuTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="reservationMenuTitle">Reservation Identification</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div class="row mt-4 mb-4">
                <div class="col-md-8 offset-md-2">
                    <form>
                      <div class="form-group">
                        <label for="reservationNR" class="col-form-label reservation_label">Reservation NB:</label>
                        <input type="text" class="form-control input_box" id="reservationNR" name="reservationNR" value="{{reservationId}}">
                      </div>
                      <div class="form-group mt-4">
                        <button type="button" class="btn btn-primary btn-block apply_button" (click)="ApplyReservation()">APPLY</button>
                      </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary apply_button" data-dismiss="modal" #closeModal>Close</button>
        </div>
      </div>
    </div>
  </div>